// @ts-nocheck
/* Store Custom Code - Start */
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchTextField, { SearchTextFieldStyles } from "@insite/content-library/Widgets/OrderHistory/SearchTextField";
import * as React from "react";
import translate from "@insite/client-framework/Translate";

export const lastNameStyles: SearchTextFieldStyles = {};
const styles = lastNameStyles;

const OrderHistorySearchLastName: React.FunctionComponent<WidgetProps> = () => {
    return (
        <SearchTextField
            styles={styles}
            parameterField="lastName"
            label={translate("Last Name")}
            inputType="text"
            placeholder=""
            testSelector="orderHistory_filterLastName"
        />
    );
};

const widgetModule: WidgetModule = {
    component: OrderHistorySearchLastName,
    definition: {
        group: "Order History",
        displayName: "Last Name",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
    },
};

export default widgetModule;
/* Store Custom Code - End */
